// import React, { useState, useEffect, useContext } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import API from '../../util/api';
// import { userLogin , fetchAnnouncements, fetchDocuments, fetchEventsAsync , selectUserRole} from '../../sagas/actions';
// // import ForgetPassword from './ForgetPassword';
// import GoogleSSOLogin from './SSO/GoogleSSOLogin';
// import { ThemeContext } from '../../context/ThemeContext';
// import { getDeviceInfo } from '../../util/getDeviceInformation';
// import PuzzleCaptcha from '../Common/PuzzleCaptcha';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';

// const OuterContainer = styled.div`
//   width: 100%;
//   margin: 0 auto;
//   max-width: 800px;
//   box-sizing: border-box;
// `;

// const TitleHeader = styled.div`
//   width: 100%;
//   background-color: #195174;
//   padding: 2px 10px;
//   border-radius: 10px 10px 0 0;
//   box-sizing: border-box;
// `;

// const LoginFormContainer = styled.div`
//   background: rgba(255, 255, 255);
//   padding: 20px;
//   border-radius: 0px 0px 10px 10px;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//   text-align: left;
//   width: 100%;
//   box-sizing: border-box;
//   max-height: 100vh;
//   overflow-y: auto;
//   margin-top: 0px;
// `;

// const Title = styled.h3`
//   color: #FFFFFF;
//   font-size: 16 px;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 10px;
//   margin-bottom: 10px;
//   font-size: 16px;
//   border: 1px solid #195174;
//   border-radius: 5px;
//   box-sizing: border-box;
// `;

// const PasswordInputWrapper = styled.div`
//   position: relative;
//   width: 100%;
// `;

// const PasswordInputField = styled(Input)`
//   padding-right: 40px;
// `;

// const EyeIcon = styled.span`
//   position: absolute;
//   top: 40%;
//   right: 10px;
//   transform: translateY(-50%);
//   cursor: pointer;
//   color: #195174;
// `;

// const ForgetPasswordLink = styled.span`
//   display: block;
//   text-align: center;
//   margin-top: 10px;
//   color: #195174;
//   cursor: pointer;

//   &:hover {
//     text-decoration: underline;
//   }
// `;

// const Button = styled.button`
//   display: block;
//   width: 100%;
//   padding: 10px;
//   margin-top: 10px;
//   font-size: 16px;
//   border: none;
//   border-radius: 5px;
//   background-color: #195174;
//   color: white;
//   cursor: pointer;
//   font-weight: bold;

//   &:hover {
//     background-color: #2980b9;
//   }

//   &:disabled {
//     background-color: #cccccc;
//     cursor: not-allowed;
//   }
// `;

// const Divider = styled.hr`
//   width: 100%;
//   margin: 20px 0;
//   border: none;
//   border-top: 1px solid #ddd;
// `;

// const CaptchaContainer = styled.div`
//   background: #f0f0f0;
//   padding: 20px;
//   border-radius: 5px;
//   margin-top: 20px;
//   box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
// `;

// const RadioContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   margin-bottom: 10px;

//   label {
//     margin-bottom: 5px;
//   }
// `;

// const Paragraph = styled.p`
//   margin-bottom: 1em;
// `;

// const Label = styled.label`
//   display: block;
//   margin-bottom: 0.5em;
//   color: #195174;
// `;

// const ErrorMessage = styled.div`
//   background-color: #f8d7da;
//   padding: 10px;
//   margin-bottom: 10px;
// `;

// const SuccessMessage = styled.div`
//   background-color: #d4edda;
//   padding: 10px;
//   margin-bottom: 10px;
// `;

// const H5Title = styled.h5`
//   margin-bottom: 10px;
// `;

// const LoginWithEmail = () => {
//   const [email, setEmail] = useState('');
//   const [phone, setPhone] = useState('');
//   const [verificationMethod, setVerificationMethod] = useState('email');
//   const [otpCode, setOtpCode] = useState('');
//   const [isEmailValid, setIsEmailValid] = useState(false);
//   const [isPhoneValid, setIsPhoneValid] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [password, setPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const [timer, setTimer] = useState(0);
//   const [captchaInput, setCaptchaInput] = useState('');
//   const [captchaSuccessMessage, setCaptchaSuccessMessage] = useState('');
//   const [captchaErrorMessage, setCaptchaErrorMessage] = useState('');
//   const [captchaTimer, setCaptchaTimer] = useState(0);
//   const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
//   const [showForgetPassword, setShowForgetPassword] = useState(false);
//   const [deviceInfo, setDeviceInfo] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showOtp, setShowOtp] = useState(false);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { setLightTheme, setDarkTheme, setAutoTheme, setZoomLevel } = useContext(ThemeContext);
//   const loginResponse = useSelector(state => state.auth.anonToken);
//   const token = useSelector(state => state.auth.token);
//   useEffect(() => {
//     if (captchaTimer > 0) {
//       const interval = setInterval(() => {
//         setCaptchaTimer((prev) => {
//           if (prev <= 1 && !otpSent) {
//             setCaptchaErrorMessage('Captcha has expired, please retry.');
//             setCaptchaSuccessMessage(null);
//             setIsCaptchaVerified(false);
//             setCaptchaInput('');
//             clearInterval(interval);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [captchaTimer]);

//   useEffect(() => {
//     const fetchDeviceInfo = async () => {
//       const info = await getDeviceInfo();
//       setDeviceInfo(info);
//     };

//     fetchDeviceInfo();
//   }, []);

//   useEffect(() => {
//     const endTime = localStorage.getItem('resendEndTime');
//     if (endTime) {
//       const remainingTime = Math.floor((new Date(endTime) - new Date()) / 1000);
//       if (remainingTime > 0) {
//         setTimer(remainingTime);
//         const interval = setInterval(() => {
//           setTimer((prev) => {
//             if (prev <= 1) {
//               clearInterval(interval);
//               return 0;
//             }
//             return prev - 1;
//           });
//         }, 1000);
//       } else {
//         localStorage.removeItem('resendEndTime');
//       }
//     }
//   }, []);

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(String(email).toLowerCase());
//   };

//   const validatePhone = (phone) => {
//     return phone && phone.length >= 10;
//   };

//   const handleEmailChange = (event) => {
//     const emailValue = event.target.value;
//     setEmail(emailValue);
//     setIsEmailValid(validateEmail(emailValue));
//   };

//   const handlePhoneChange = (phone) => {
//     setPhone(phone);
//     setIsPhoneValid(validatePhone(phone));
//   };

//   const handleOTPChange = (event) => {
//     setOtpCode(event.target.value);
//   };

//   const handlePasswordChange = (event) => {
//     setPassword(event.target.value);
//   };

//   const startTimer = () => {
//     const endTime = new Date(new Date().getTime() + 30000);
//     localStorage.setItem('resendEndTime', endTime);
//     setTimer(30);
//   };

//   useEffect(() => {
//     if (timer > 0) {
//       const interval = setInterval(() => {
//         setTimer((prev) => {
//           if (prev <= 1) {
//             clearInterval(interval);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [timer]);

//   const sendOTP = async () => {
//     try {
//       const response = await API.loginOTP(
//         email,
//       );
//       if (response.status === 'Failed') {
//         setMessage(response.message);
//       } else {
//         setMessage(response.message);
//         setOtpSent(true);
//         startTimer();
//       }
//     } catch (error) {
//       console.error('Error sending OTP:', error);
//       setMessage('An error occurred while sending OTP. Please try again.');
//     }
//   };

//   const resendOTP = () => {
//     sendOTP();
//   };

//   const submitOTP = async () => {
//     try {
//       const response = await API.verifyLoginOTP(
//        email,
//        otpCode,
//       );
//       if (response.status === 'Success') {
//         setOtpVerified(true);
//         setMessage(''); // Clear any previous messages
//       } else {
//         setMessage(response.message);
//       }
//     } catch (error) {
//       console.error('Error verifying OTP:', error);
//     }
//   };

//   const handleBackButton = () => {
//     setShowForgetPassword(false); // Go back to login form
//   };

//   const loginAdult = async () => {
//     try {
//       const response = await API.userLogin(email, password);
//       if (!response.access_token) {
//         setMessage("Login Failed : Please make sure that entered password is correct. ");
//       } else {
//         dispatch(userLogin(response));
//         navigate('/myinfo')
//         // const device_information_response = await API.updatePNToken(response.user.user_id,deviceInfo.device_type, "abcderfghi1234", deviceInfo.device_id, deviceInfo.make,deviceInfo.model, deviceInfo.os, deviceInfo.os_version,response.sessid, deviceInfo.ip ,deviceInfo.location)
//         // // if (device_information_response.status == "Failed") {
//         // //   console.log("PN Token update Failed");
//         // // }
//         // // else {
//         // //   console.log("PN Token Successfully Updated");
//         // // }
//         // const { preference, roles, isdToken } = response.user;
//         // if (preference) {
//         //   if (preference.mode) {
//         //     switch (preference.mode) {
//         //       case 'light':
//         //         setLightTheme();
//         //         break;
//         //       case 'dark':
//         //         setDarkTheme();
//         //         break;
//         //       case 'auto':
//         //       default:
//         //         setAutoTheme();
//         //         break;
//         //     }
//         //   }
//         //   if (preference.zoom) {
//         //     setZoomLevel(Number(preference.zoom));
//         //     document.body.style.zoom = Number(preference.zoom) / 100;
//         //   }
//         // }
//       }
//     } catch (error) {
//       console.error('Error verifying password:', error);
//       setMessage('An error occurred while verifying the password. Please try again.');
//     }
//   };

//   const handleSendCode = async (event) => {
//     event.preventDefault();
//     if (!isCaptchaVerified) {
//       setMessage('Please verify the captcha first.');
//       return;
//     }
//     sendOTP();
//   };

//   if(showForgetPassword) {
//     // return (<ForgetPassword onBack={handleBackButton} />);
//   }

//   return (
//     <OuterContainer>
//     <TitleHeader>
//       <Title>Login</Title>
//       </TitleHeader>
//     <LoginFormContainer>
//       {otpVerified ? (
//         <>
//           <Paragraph>Please enter the password associated with the account.</Paragraph>
//           <Label>
//             Email:
//             <Input
//               type="email"
//               value={email}
//               onChange={handleEmailChange}
//               disabled
//             />
//           </Label>
//           <Label>
//             Password:
//             <PasswordInputWrapper>
//               <PasswordInputField
//                 type={showPassword ? 'text' : 'password'}
//                 value={password}
//                 onChange={handlePasswordChange}
//               />
//               <EyeIcon onClick={() => setShowPassword(!showPassword)}>
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </EyeIcon>
//             </PasswordInputWrapper>
//           </Label>
//           {message && <ErrorMessage>{message}</ErrorMessage>}
//           <Button onClick={loginAdult}>Submit</Button>
//         </>
//       ) : otpSent ? (
//         <>
//           <Label>
//             Please enter the code you received:
//             <PasswordInputWrapper>
//               <PasswordInputField
//                 type={showOtp ? 'text' : 'password'}
//                 value={otpCode}
//                 onChange={handleOTPChange}
//               />
//               <EyeIcon onClick={() => setShowOtp(!showOtp)}>
//                 {showOtp ? <FaEyeSlash /> : <FaEye />}
//               </EyeIcon>
//             </PasswordInputWrapper>
//           </Label>
//           <SuccessMessage>{message}</SuccessMessage>
//           <Button onClick={resendOTP} disabled={timer > 0}>
//             {timer > 0 ? `Resend Code (${timer}s)` : 'Resend Code'}
//           </Button>
//           <Button onClick={submitOTP}>Submit</Button>
//         </>
//       ) : (
//         <>
//           <Paragraph>If you have an account with us, please log in.</Paragraph>
//           <Paragraph>Please use your email address to verify your identity.</Paragraph>
//             <Input
//               type="email"
//               placeholder="Email"
//               value={email}
//               onChange={handleEmailChange}
//               required
//             />
//           <CaptchaContainer>
//             <H5Title> Security Check: </H5Title>
//             <Paragraph>Please solve the puzzle below to verify that you're a human.</Paragraph>
//             <PuzzleCaptcha
//               onVerified={setIsCaptchaVerified}
//             />
//             {captchaSuccessMessage && <SuccessMessage>{captchaSuccessMessage}</SuccessMessage>}
//             {captchaErrorMessage && <ErrorMessage>{captchaErrorMessage}</ErrorMessage>}
//           </CaptchaContainer>
//           {message && <ErrorMessage>{message}</ErrorMessage>}
//           <ForgetPasswordLink onClick={() => {setShowForgetPassword(true)}}>Forget Password?</ForgetPasswordLink>
//           <Button
//             type="submit"
//             onClick={handleSendCode}
//             disabled={
//               verificationMethod === 'email'
//                 ? !isEmailValid || !isCaptchaVerified || timer > 0
//                 : !isPhoneValid || !isCaptchaVerified || timer > 0
//             }
//           >
//             {timer > 0 ? `Resend Code (${timer}s)` : 'Send Code'}
//           </Button>
//            <Divider />
//            <Paragraph>
//             Or continue with your Google account for an even faster login.
//           </Paragraph>
//           <GoogleSSOLogin />
//         </>
//       )}
//     </LoginFormContainer>
//     </OuterContainer>
//   );
// };

// export default LoginWithEmail;
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  lazy,
  Suspense,
  useMemo,
} from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import API from "../../util/api";
import { userLogin, classLinkSSOLogin } from "../../sagas/actions";
import ClassLinkSSOLogin from "./SSO/ClassLinkSSOLogin";
import MicrosoftSSOLogin from "./SSO/MicrosoftSSOLogin";
import { ThemeContext } from "../../context/ThemeContext";
import { getDeviceInfo } from "../../util/getDeviceInformation";
import PuzzleCaptcha from "../Common/PuzzleCaptcha";
import { fetchFreshPixelToken } from "../../util/pixelToken";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import useMicrosoftSSO from "../../hooks/useMicrosoftSSO";
import {
  readClassLinkState,
  clearClassLinkState,
  getClassLinkRedirectUri,
} from "../../util/classLinkSSOConfig";

const SSO_AUTH_CLIENT_ID = import.meta.env.VITE_SSO_AUTH_CLIENT_ID || "";
const SSO_AUTH_CLIENT_SECRET =
  import.meta.env.VITE_SSO_AUTH_CLIENT_SECRET || "";

const GoogleSSOLogin = lazy(() => import("./SSO/GoogleSSOLogin"));

const OuterContainer = styled.div`
  width: 100%;
  margin: 24px auto;
  max-width: 1100px;
  box-sizing: border-box;
`;

const TitleHeader = styled.div`
  width: 100%;
  background-color: #195174;
  padding: 10px 16px;
  border-radius: 12px 12px 0 0;
  box-sizing: border-box;
`;

const Title = styled.h3`
  color: #ffffff;
  font-size: 18px;
  margin: 0;
`;

const Shell = styled.div`
  background: #fff;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

/* Three-column grid: Left | Divider | Right */
const Split = styled.div`
  display: grid;
  grid-template-columns: 5fr auto 7fr; /* left smaller, right larger */
  align-items: stretch;
  gap: 24px;
  padding: 24px;
  min-height: ${({ $compact }) => ($compact ? "auto" : "520px")};

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
`;

const Panel = styled.div`
  background: #ffffff;
  border: 1px solid #eef2f6;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;

  @media (max-width: 900px) {
    padding: 16px;
  }
`;

const EmailPanel = styled(Panel)`
  box-shadow: inset 0 0 0 1px #f2f6fb;
`;

const SSOPanel = styled(Panel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 18px;
  text-align: center;
`;

/* Divider column with centered "or" badge and a visible pipe */
const DividerCol = styled.div`
  position: relative;
  width: 1px;
  background: #e6e9ee;

  &:after {
    content: "or";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    color: #5e6a76;
    border: 1px solid #e6e9ee;
    border-radius: 999px;
    padding: 6px 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-size: 11px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  /* Optional: show an actual pipe character visually on top of the line */
  &:before {
    content: "|";
    position: absolute;
    left: 50%;
    top: 12px;
    transform: translateX(-50%);
    color: #cfd6de;
    font-weight: 700;
    font-size: 16px;
    opacity: 0.7;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const SectionTitle = styled.h4`
  margin: 0 0 12px;
  color: #0c2b3f;
  font-size: 18px;
`;

const Paragraph = styled.p`
  margin: 0 0 12px;
  color: #3a4a57;
  line-height: 1.4;
`;

const Label = styled.label`
  display: block;
  margin: 12px 0 6px;
  color: #195174;
  font-weight: 600;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 12px;
  margin-bottom: 4px;
  font-size: 16px;
  border: 1px solid #c8d6e5;
  border-radius: 8px;
  box-sizing: border-box;
  outline: none;
  transition:
    box-shadow 0.15s ease,
    border-color 0.15s ease;
  &:focus {
    border-color: #195174;
    box-shadow: 0 0 0 4px rgba(25, 81, 116, 0.08);
  }
`;

const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PasswordInputField = styled(Input)`
  padding-right: 44px;
`;

const OtpInputField = styled(Input).attrs({
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]*",
  autoComplete: "one-time-code",
  autoCorrect: "off",
  autoCapitalize: "none",
  spellCheck: false,
  "data-lpignore": "true",
})`
  padding-right: 44px;
  ${({ $masked }) =>
    $masked
      ? `-webkit-text-security: disc;
         text-security: disc;`
      : ""};
`;

const EyeIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #195174;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 10px 14px;
  font-size: 15px;
  border: none;
  border-radius: 8px;
  background-color: #195174;
  color: white;
  cursor: pointer;
  font-weight: 700;
  transition:
    background 0.15s ease,
    transform 0.02s ease;

  &:hover {
    background-color: #1f628d;
  }
  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background-color: #cbd6df;
    cursor: not-allowed;
  }
`;

const GhostButton = styled(Button)`
  background: #eef4f8;
  color: #195174;
  &:hover {
    background: #e5eff6;
  }
`;

const TextLink = styled(Link)`
  color: #195174;
  font-weight: 600;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Note = styled.div`
  color: #708496;
  font-size: 13px;
  margin-top: 8px;
`;

const SsoPlaceholder = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px dashed rgba(25, 81, 116, 0.35);
  background: rgba(25, 81, 116, 0.05);
  color: #195174;
  font-size: 13px;
  text-align: center;
`;

const ClassLinkStatusMessage = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: #195174;
  text-align: center;
`;

const ClassLinkErrorMessage = styled.div`
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fdecef;
  color: #8b1e2f;
  border: 1px solid #f5c0c9;
  font-size: 13px;
  text-align: center;
`;

const HoneypotField = styled.div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

const CaptchaContainer = styled.div`
  background: #f7fafc;
  border: 1px dashed #d8e5ef;
  padding: 16px;
  border-radius: 10px;
  margin: 14px 0 6px;
`;

const ErrorMessage = styled.div`
  background-color: #fdecef;
  color: #8b1e2f;
  border: 1px solid #f5c0c9;
  padding: 10px 12px;
  border-radius: 8px;
  margin: 10px 0 0;
`;

const SuccessMessage = styled.div`
  background-color: #e9f9ee;
  color: #0f5d35;
  border: 1px solid #bce3c9;
  padding: 10px 12px;
  border-radius: 8px;
  margin: 10px 0 0;
`;

const H5Title = styled.h5`
  margin: 0 0 8px;
  color: #0c2b3f;
`;

const HelperText = styled.div`
  font-size: 12px;
  color: #6d7f8d;
`;

const LoginWithEmail = ({
  initialOtpVerified = false,
  isEmailReadOnly = false,
}) => {
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(initialOtpVerified);
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [timer, setTimer] = useState(0);
  const [captchaSuccessMessage, setCaptchaSuccessMessage] = useState("");
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [classLinkStatus, setClassLinkStatus] = useState("");
  const [classLinkError, setClassLinkError] = useState("");
  const [classLinkProcessing, setClassLinkProcessing] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [mountGoogleSso, setMountGoogleSso] = useState(false);
  const honeypotRef = useRef(null);
  const honeypotSnapshotRef = useRef("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isOsceolaLogin = location.pathname.startsWith("/user/login/osceola");
  const { setLightTheme, setDarkTheme, setAutoTheme, setZoomLevel } =
    useContext(ThemeContext);
  const microsoftQueryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      code: params.get("code"),
      state: params.get("state"),
      sessionState: params.get("session_state"),
      error: params.get("error"),
      errorDescription: params.get("error_description"),
    };
  }, [location.search]);
  const isMicrosoftCallback = useMemo(() => {
    if (!microsoftQueryParams.code && !microsoftQueryParams.error) {
      return false;
    }
    return Boolean(
      (microsoftQueryParams.state || "").startsWith("msso_") ||
      microsoftQueryParams.sessionState ||
      location.pathname.includes("/sso/microsoft/callback"),
    );
  }, [
    location.pathname,
    microsoftQueryParams.code,
    microsoftQueryParams.error,
    microsoftQueryParams.sessionState,
    microsoftQueryParams.state,
  ]);
  const { status: microsoftStatus, errorMessage: microsoftError } =
    useMicrosoftSSO({
      enabled: isMicrosoftCallback,
      code: microsoftQueryParams.code,
      stateParam: microsoftQueryParams.state,
      error: microsoftQueryParams.error,
      errorDescription: microsoftQueryParams.errorDescription,
    });

  useEffect(() => {
    const fetchDeviceInfo = async () => {
      setDeviceInfo(await getDeviceInfo());
    };
    let deviceInfo; // eslint appease; deviceInfo is unused here afterwards
    fetchDeviceInfo();
  }, []);

  useEffect(() => {
    if (honeypotRef.current) {
      honeypotRef.current.value = "";
    }
    honeypotSnapshotRef.current = "";
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setMountGoogleSso(true), 0);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const endTime = localStorage.getItem("resendEndTime");
    if (endTime) {
      const remainingTime = Math.floor((new Date(endTime) - new Date()) / 1000);
      if (remainingTime > 0) {
        setTimer(remainingTime);
        const interval = setInterval(() => {
          setTimer((prev) =>
            prev <= 1 ? (clearInterval(interval), 0) : prev - 1,
          );
        }, 1000);
        return () => clearInterval(interval);
      } else {
        localStorage.removeItem("resendEndTime");
      }
    }
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) =>
          prev <= 1 ? (clearInterval(interval), 0) : prev - 1,
        );
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const stateParam = params.get("state");
    const error = params.get("error");
    const errorDescription = params.get("error_description");
    const accessToken = params.get("access_token");
    const isClassLinkCallback = Boolean(code || error);

    if (isMicrosoftCallback) {
      return;
    }

    if (accessToken && !isClassLinkCallback) {
      return;
    }

    if (location.search && isClassLinkCallback) {
      console.info("[ClassLinkSSO] Callback query detected on login page", {
        rawSearch: location.search,
        codePresent: Boolean(code),
        stateParam,
        error,
      });
    }

    if (!isClassLinkCallback) {
      return;
    }

    if (classLinkProcessing) {
      return;
    }

    setClassLinkProcessing(true);
    setClassLinkStatus("");
    setClassLinkError("");

    const cleanPath = `${location.pathname}${location.hash || ""}`;
    console.info("[ClassLinkSSO] Cleaning up URL params after callback", {
      originalPath: location.pathname,
      cleanedPath: cleanPath,
    });
    navigate(cleanPath, { replace: true });

    if (error) {
      const message =
        errorDescription ||
        (error === "access_denied"
          ? "ClassLink sign-in was cancelled. Please try again."
          : "We could not complete your ClassLink sign-in.");
      setClassLinkError(message);
      clearClassLinkState();
      setClassLinkProcessing(false);
      return;
    }

    if (!code) {
      setClassLinkError(
        "Missing authorization code. Please start the ClassLink sign-in again.",
      );
      clearClassLinkState();
      setClassLinkProcessing(false);
      return;
    }

    const expectedState = readClassLinkState();
    if (!stateParam || !expectedState || stateParam !== expectedState) {
      setClassLinkError("Your sign-in session expired. Please try again.");
      clearClassLinkState();
      setClassLinkProcessing(false);
      console.warn("[ClassLinkSSO] State mismatch detected", {
        receivedState: stateParam,
        expectedState,
      });
      return;
    }

    const completeSignIn = async () => {
      try {
        setClassLinkStatus("Securing your ClassLink sign-in…");
        console.info("[ClassLinkSSO] Initiating backend exchange via saga", {
          codeSnippet: code?.slice(0, 12) || null,
        });
        const pixelToken = await fetchFreshPixelToken();
        if (!pixelToken) {
          console.error(
            "[ClassLinkSSO] Pixel token missing while finishing callback",
          );
          throw new Error("missing_pixel_token");
        }

        dispatch(
          classLinkSSOLogin({
            code,
            redirectUri: getClassLinkRedirectUri(),
            pixelToken,
          }),
        );
        console.info("[ClassLinkSSO] Dispatched saga with authorization code");
        setClassLinkStatus(null);
      } catch (err) {
        console.error("ClassLink SSO completion error", err);
        const message =
          err?.message === "missing_pixel_token"
            ? "Unable to secure the sign-in request. Please refresh and try again."
            : "We hit a snag while finishing ClassLink sign-in. Please try again.";
        setClassLinkError(message);
        setClassLinkStatus("");
      } finally {
        clearClassLinkState();
        setClassLinkProcessing(false);
      }
    };

    completeSignIn();
  }, [
    classLinkProcessing,
    dispatch,
    location.hash,
    location.pathname,
    location.search,
    navigate,
    isMicrosoftCallback,
  ]);

  const validateEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).toLowerCase());

  const handleEmailChange = (event) => {
    const nextEmail = event.target.value;
    setEmail(nextEmail);
    setIsEmailValid(validateEmail(nextEmail));
  };

  const handleOTPChange = (event) => setOtpCode(event.target.value);

  const handlePasswordChange = (event) => setPassword(event.target.value);

  const startTimer = () => {
    const endTime = new Date(new Date().getTime() + 30000);
    localStorage.setItem("resendEndTime", endTime);
    setTimer(30);
  };

  const getHoneypotPayload = () => {
    if (honeypotRef.current && typeof honeypotRef.current.value === "string") {
      return honeypotRef.current.value;
    }

    if (typeof document !== "undefined") {
      const node = document.querySelector('input[name="website_url"]');
      if (node && typeof node.value === "string") {
        return node.value;
      }
    }

    return "";
  };

  const sendOTP = async () => {
    try {
      const honeypotPayload = getHoneypotPayload();
      honeypotSnapshotRef.current = honeypotPayload;
      let pixelToken;
      try {
        pixelToken = await fetchFreshPixelToken();
      } catch (error) {
        console.warn("Unable to obtain pixel token for OTP request.", error);
        setMessage(
          "Unable to initiate verification. Please refresh and try again.",
        );
        return;
      }

      if (!pixelToken) {
        setMessage(
          "Unable to initiate verification. Please refresh and try again.",
        );
        return;
      }

      const response = await API.loginOTP(email, pixelToken, honeypotPayload);
      if (response.status === "Failed") {
        setMessage(response.message);
      } else {
        setMessage(response.message);
        setOtpSent(true);
        startTimer();
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setMessage("An error occurred while sending OTP. Please try again.");
    }
  };

  const resendOTP = () => sendOTP();

  const submitOTP = async () => {
    try {
      const honeypotPayload =
        honeypotSnapshotRef.current || getHoneypotPayload();
      let pixelToken;
      try {
        pixelToken = await fetchFreshPixelToken();
      } catch (error) {
        console.warn(
          "Unable to obtain pixel token for OTP verification.",
          error,
        );
        setMessage(
          "Unable to verify at this time. Please refresh and try again.",
        );
        return;
      }

      if (!pixelToken) {
        setMessage(
          "Unable to verify at this time. Please refresh and try again.",
        );
        return;
      }

      const response = await API.verifyLoginOTP(
        email,
        otpCode,
        pixelToken,
        honeypotPayload,
      );
      if (response.status === "Success") {
        setOtpVerified(true);
        setMessage("");
      } else {
        setMessage(response.message);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setMessage(
        "An error occurred while verifying the code. Please try again.",
      );
    }
  };

  const loginAdult = async () => {
    try {
      let pixelToken;
      try {
        pixelToken = await fetchFreshPixelToken();
      } catch (error) {
        console.warn("Unable to obtain pixel token for login request.", error);
        setMessage("Unable to login. Please refresh and try again.");
        return;
      }

      if (!pixelToken) {
        setMessage("Unable to login. Please refresh and try again.");
        return;
      }

      const loginOptions = isOsceolaLogin
        ? {
            grant_type: "google_sso",
            is_osceola_classlink_sso: 1,
            client_id: SSO_AUTH_CLIENT_ID,
            client_secret: SSO_AUTH_CLIENT_SECRET,
            skipCodeChallenge: true,
          }
        : undefined;

      const response = await API.userLogin(
        email,
        password,
        pixelToken,
        loginOptions,
      );
      if (!response.access_token) {
        setMessage(
          "Login Failed : Please make sure that entered password is correct.",
        );
      } else {
        dispatch(userLogin(response));
        navigate("/myinfo");
      }
    } catch (error) {
      console.error("Error verifying password:", error);
      setMessage(
        "An error occurred while verifying the password. Please try again.",
      );
    }
  };

  const handleSendCode = async (event) => {
    event.preventDefault();
    if (!isCaptchaVerified) {
      setMessage("Please verify the captcha first.");
      return;
    }
    sendOTP();
  };

  return (
    <OuterContainer>
      <TitleHeader>
        <Title>Login</Title>
      </TitleHeader>

      <Shell>
        <Split $compact={otpSent && !otpVerified}>
          {/* LEFT: EMAIL LOGIN (smaller) */}
          <EmailPanel>
            <HoneypotField aria-hidden="true">
              <label htmlFor="website_url">Website (optional)</label>
              <input
                id="website_url"
                name="website_url"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck={false}
                ref={honeypotRef}
              />
            </HoneypotField>

            <SectionTitle>Login with Email</SectionTitle>

            {otpVerified ? (
              <>
                <Paragraph>
                  Please enter the password associated with the account.
                </Paragraph>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  readOnly={isEmailReadOnly}
                />
                <Label>Password</Label>
                <PasswordInputWrapper>
                  <PasswordInputField
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <EyeIcon onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </EyeIcon>
                </PasswordInputWrapper>

                {message && <ErrorMessage>{message}</ErrorMessage>}
                <ButtonRow>
                  <Button onClick={loginAdult}>Submit</Button>
                  {/* 1) Open /password/request */}
                  <GhostButton as={Link} to="/password/request">
                    Forgot Password?
                  </GhostButton>
                </ButtonRow>
              </>
            ) : otpSent ? (
              <>
                <Label>Enter the code you received</Label>
                <PasswordInputWrapper>
                  <OtpInputField
                    $masked={!showOtp}
                    value={otpCode}
                    onChange={handleOTPChange}
                    placeholder="6-digit code"
                  />
                  <EyeIcon onClick={() => setShowOtp(!showOtp)}>
                    {showOtp ? <FaEyeSlash /> : <FaEye />}
                  </EyeIcon>
                </PasswordInputWrapper>

                {message && <SuccessMessage>{message}</SuccessMessage>}

                <ButtonRow>
                  <Button onClick={submitOTP}>Submit</Button>
                  <GhostButton onClick={resendOTP} disabled={timer > 0}>
                    {timer > 0 ? `Resend Code (${timer}s)` : "Resend Code"}
                  </GhostButton>
                </ButtonRow>
                <Paragraph>
                  Didn’t receive the code? Check your spam folder.{" "}
                  <TextLink to="/password/request">Need help?</TextLink>
                </Paragraph>
              </>
            ) : (
              <>
                <Paragraph>
                  If you have an account with us, please log in.
                </Paragraph>
                <Paragraph>
                  Please use your email address to verify your identity.
                </Paragraph>

                <Label>Email</Label>
                <Input
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  readOnly={isEmailReadOnly}
                />
                <HelperText>
                  We’ll send a one-time code to verify it’s you.
                </HelperText>

                <CaptchaContainer>
                  <H5Title>Security Check</H5Title>
                  <Paragraph>
                    Complete the puzzle below to verify you’re human.
                  </Paragraph>
                  <PuzzleCaptcha onVerified={setIsCaptchaVerified} />
                  {captchaSuccessMessage && (
                    <SuccessMessage>{captchaSuccessMessage}</SuccessMessage>
                  )}
                  {captchaErrorMessage && (
                    <ErrorMessage>{captchaErrorMessage}</ErrorMessage>
                  )}
                </CaptchaContainer>

                {message && <ErrorMessage>{message}</ErrorMessage>}

                <ButtonRow>
                  <Button
                    type="submit"
                    onClick={handleSendCode}
                    disabled={!isEmailValid || !isCaptchaVerified || timer > 0}
                  >
                    {timer > 0 ? `Resend Code (${timer}s)` : "Send Code"}
                  </Button>
                  {/* 1) Open /password/request */}
                  <GhostButton as={Link} to="/password/request">
                    Forgot Password?
                  </GhostButton>
                </ButtonRow>
              </>
            )}
          </EmailPanel>

          {/* 2) Divider with OR in the middle */}
          <DividerCol />

          {/* RIGHT: SSO (larger) */}
          <SSOPanel>
            <SectionTitle>Use Single Sign-On</SectionTitle>
            <Paragraph>
              Log in quickly with your organization account.
            </Paragraph>
            {mountGoogleSso ? (
              <Suspense
                fallback={
                  <SsoPlaceholder>Loading Google Sign-In…</SsoPlaceholder>
                }
              >
                <GoogleSSOLogin />
              </Suspense>
            ) : (
              <SsoPlaceholder>Loading Google Sign-In…</SsoPlaceholder>
            )}
            <MicrosoftSSOLogin loginHint={email} />
            {microsoftStatus && (
              <ClassLinkStatusMessage>{microsoftStatus}</ClassLinkStatusMessage>
            )}
            {microsoftError && (
              <ClassLinkErrorMessage>{microsoftError}</ClassLinkErrorMessage>
            )}
            <ClassLinkSSOLogin />
            {classLinkStatus && (
              <ClassLinkStatusMessage>{classLinkStatus}</ClassLinkStatusMessage>
            )}
            {classLinkError && (
              <ClassLinkErrorMessage>{classLinkError}</ClassLinkErrorMessage>
            )}
            <Note>
              By continuing, you agree to our Terms and acknowledge the Privacy
              Policy.
            </Note>
          </SSOPanel>
        </Split>
      </Shell>
    </OuterContainer>
  );
};

export default LoginWithEmail;
